// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".video_player__play_btn[data-v-0ebe4e27]{\n  fill:rgba(0,0,0,.4);\n  filter:drop-shadow(2px 2px 8px rgba(0,0,0,.2));\n  -webkit-backdrop-filter:blur(10px);\n          backdrop-filter:blur(10px)\n}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
